<template>
  <div :class="['alert', {[`alert-${type}`]: type}]">
    <div v-if="icon" class="flex-no-shrink">
      <svgicon :name="icon" class="w-6 h-6 mr-2"></svgicon>
    </div>
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: null,
    },

    icon: {
      type: String,
      default: null,
    },
  },
};
</script>
